import authsession from './authsession';

const deleteProductFun = ( api, sendData, notifyError, notifyInfo, notifySuccess, dispatch, getProductsDash, setModal, setDetailsWindow, setproductDelete ) => {

    api({
        method: 'post',
        headers: { 'Authorization': authsession() },
        url: 'productc.php?fun=delete',
        data: sendData,
    })
        .then((response) => {

            if (response.data.uspesno) {
                notifySuccess(response.data.uspesno);
                dispatch(getProductsDash());
                setDetailsWindow(false);
                setModal(false);
                setproductDelete({ id_kat: '', })
            } else if (response.data.greska) {
                notifyError(response.data.greska);

            } else if (response.data.info) {
                notifyInfo(response.data.info);
            }
        })
}

export default deleteProductFun